module.exports = __webpack_public_path__ + "static/media/logo.1f85b061.png";